import { Logging } from './interceptors/logging';
import { Auth } from './interceptors/auth';
import { BaseUrl } from './interceptors/baseUrl';
import { SentryInterceptor, CorrelationInterceptor } from '@petseo/shared';
import {
  axios,
  serviceVendorsClient,
  serviceTypesClient,
  homeClient,
  placesClient,
  subscriptionClient,
  reservationsClient,
} from './api/petseo.client.wrapper';

BaseUrl.addBaseUrlInterceptor(axios);
Auth.addAuthInterceptors(axios);
CorrelationInterceptor.addCorrelationInterceptor(axios);
SentryInterceptor.addSentryInterceptors(axios);
Logging.addLoggingInterceptors(axios);

export { serviceVendorsClient, serviceTypesClient, homeClient, placesClient, subscriptionClient, reservationsClient };
